<template>
    <div class="addArea">
        <div class="search">
            <el-form :inline="true" :model="searchDatas" ref="searchDatas" :rules="rules" class="demo-form-inline">
                <el-form-item label="名称" prop="name">
                    <el-input  v-model="searchDatas.name" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="区域">
                    <el-cascader
                            v-model="checkedCodesS"
                            placeholder="请选择行政区域"
                            :options="optionsS"
                            @active-item-change="codeCheckedS"
                            :props="props"
                            filterable
                            change-on-select
                            separator="|"
                    ></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getListData('searchDatas')">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table">
            <el-table
                    id="etable"
                    border
                    :data="tableData"
                    size="mini "
                    height="350"
                    :header-cell-style="tableHeaderColor"
                    @selection-change="handleSelectionChange"
                    style="borderRadius:5px; margin: auto"
            >
                <el-table-column
                        type="selection"
                        width="40">
                </el-table-column>
                <el-table-column
                        label="推荐指数"
                        width="200">
                    <template slot-scope="scope">
                        <el-input-number
                                v-model="scope.row.num"
                                @change="handleChange($event,scope.row)"
                                :min="1" :max="5"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="addType != 3"
                        prop="name"
                        label="名称"
                        align="center"
                >
                </el-table-column>
                    <el-table-column
                            v-if="addType == 3"
                            prop="title"
                            label="名称"
                            align="center"
                    >
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        small
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                        :page-size="size"
                        :current-page="page"
                        @current-change="currentChange"
                ></el-pagination>
            </div>
        </div>

        <div class="btn">
            <el-button @click="doClose">取 消</el-button>
            <el-button type="primary" @click="doSubmit">确 定</el-button>
        </div>
    </div>

</template>
<script>
    export default {
        props: ["addType", 'areaCode','id'],
        data() {
            return {
                tableHeaderColor({row, column, rowIndex, columnIndex}) {
                    if (rowIndex === 0) {
                        return "  background-color: #e9eef3;border-color: #fff;ont-weight: bold;color: #515a6e;";
                    }
                },
                total: 0,
                size: 10,
                page: 1,
                tableData: [],
                recommendThematicDTOList: [],//列表选择的项

                searchDatas: { // 按照区域搜索
                    name: '',
                    code: this.areaCode
                },
                rules: {
                    name: [
                        {max: 20, message: '长度在 1 到 10 个字符', trigger: 'blur'},
                        {
                            type: "string",
                            pattern: this.regex.chennum_,
                            message: "请输入正确的名称",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            pattern: this.regex.illcharacter,
                            message: "含有非法字符",
                            trigger: "blur"
                        }
                    ],
                },

                checkedCodesS: [],
                optionsS: [],
                props: {
                    label: 'label',
                    value: 'value',
                    children: 'children'
                },

            };
        },
        computed:{
        },
        methods: {
            addOrEdit() { // 列表数据
                let addType = this.addType
                let sortUrl = '';
                let  sortParams = {
                    name: this.searchDatas.name,
                    areaCode: this.searchDatas.code,
                    destId:this.id,
                    page:this.page,
                    size: 10
                }
                if (addType === 1) {
                    sortUrl = '/wtcp-selftourism/selfDestinationInfo/select/findSelectScenicsPage'
                }else if(addType === 2){
                    sortUrl = '/wtcp-selftourism/selfDestinationInfo/select/findSelectAgritainmentsPage'
                }else if(addType === 3){
                    sortUrl = '/wtcp-selftourism/selfDestinationInfo/select/findSelectTipsPage'
                    sortParams = {
                        title: this.searchDatas.name,
                        areaCode: this.searchDatas.code,
                        destId:this.id,
                        page:this.page,
                        size: 10
                    }
                }
                this.request.get(sortUrl, {...sortParams}).then((res) => {
                    if (res.status === 1) {
                        res.data.content.forEach(item => {
                            item.num = 1
                        })
                        this.tableData = res.data.content
                        this.total = Number(res.data.totalElements)
                    }else {
                        this.$message.error("获取失败");
                    }
                }).catch(() => {
                    this.$message.error("获取失败");
                });
            },

            /*行政区域选择*/
            codeCheckedS(item) {
                this.checkedCodesS = item;
                let code = '';
                if (!item || item.length <= 0) {
                    code = '';
                } else {
                    this.searchDatas.code = item[item.length - 1];
                    let names = [];
                    for (let cd of item) {
                        let name = this.findAreaNameS(cd, this.optionsS);
                        names.push(name)
                    }
                    this.getCitysS(item[item.length - 1]);
                }

            },
            findAreaNameS(code, options) {
                if (!options || options.length === 0) {
                    return '';
                }
                for (let item of options) {
                    if (item.value == code) {
                        return item.label;
                    }
                    if (item.children && item.children.length > 0) {
                        return this.findAreaNameS(code, item.children);
                    }
                }
            },
            handleCitysS(cityList, pcode, option) {
                if (pcode === 0) {
                    this.optionsS = cityList
                } else {
                    for (let item of option) {
                        if (item.value == pcode) {
                            item.children = cityList;
                            return;
                        }
                        if (item.children) {
                            this.handleCitysS(cityList, pcode, item.children);
                        }
                    }
                }

            },
            getCitysS(pcode) {
                return new Promise((resolve, reject) => {
                    this.request.get("/wtcp-coder/area/list", {pcode: pcode}).then(res => {
                        if (res.status === 1) {
                            let option = [];
                            if (res.data && res.data.length > 0) {
                                for (let item of res.data) {
                                    option.push({
                                        value: item.code,
                                        label: item.name,
                                        children: item.code && item.code.length < 9 ? [] : undefined
                                    });
                                }
                            }
                            this.handleCitysS(option, pcode, this.optionsS);
                            resolve(res);
                        } else {
                            reject(res);
                        }
                    }).catch(res => {
                        reject(res);
                    });
                })
            },
            getArea() {
                let checkedCodesS = [];
                let areaCode = this.areaCode
                if (areaCode && areaCode !== "") {
                    if (areaCode.length === 2) {
                        checkedCodesS.push(areaCode);
                        this.getCitysS(0).then(res => {
                            this.checkedCodesS = checkedCodesS;
                        });
                    } else if (areaCode.length === 4) {
                        checkedCodesS.push(areaCode.substr(0, 2));
                        checkedCodesS.push(areaCode);
                        this.getCitysS(0).then(res => {
                            this.getCitysS(checkedCodesS[0]).then(res => {
                                this.checkedCodesS = checkedCodesS;
                            });
                        });
                    } else if (areaCode.length === 6) {
                        checkedCodesS.push(areaCode.substr(0, 2));
                        checkedCodesS.push(areaCode.substr(0, 4));
                        checkedCodesS.push(areaCode);
                        this.getCitysS(0).then(res => {
                            this.getCitysS(checkedCodesS[0]).then(res => {
                                this.getCitysS(checkedCodesS[1]).then(res => {
                                    this.checkedCodesS = checkedCodesS;
                                });
                            });
                        });
                    } else if (areaCode.length === 9) {
                        checkedCodesS.push(areaCode.substr(0, 2));
                        checkedCodesS.push(areaCode.substr(0, 4));
                        checkedCodesS.push(areaCode.substr(0, 6));
                        checkedCodesS.push(areaCode);
                        this.getCitysS(0).then(res => {
                            this.getCitysS(checkedCodesS[0]).then(res => {
                                this.getCitysS(checkedCodesS[1]).then(res => {
                                    this.getCitysS(checkedCodesS[2]).then(res => {
                                        this.checkedCodesS = checkedCodesS;
                                    });
                                });
                            });
                        });
                    }
                }
            },
            /*行政区域选择*/

            refresh() { // 刷新列表
                this.addOrEdit()
            },
            doSubmit: function (e) {
                let sortParams = {
                    areaCode: this.areaCode,
                    destinationTypeId: this.addType,
                    destinationId:this.id,
                    recommendThematicDTOList: this.recommendThematicDTOList
                };
                if(this.recommendThematicDTOList.length === 0){
                    this.$message.error('请至少选择一项');
                }else {
                    this.request.post("/wtcp-selftourism/selfDestinationInfo", sortParams).then(res => {
                        if (res.status === 1) {
                            this.$emit('doRefresh')
                            this.$message.success("添加成功");
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(() => {
                        this.$message.error("获取失败");
                    });
                }

            },
            doClose() { // 取消弹窗
                this.$emit('doRefresh')
            },
            handleChange(val, row) { // 修改权重接口
                // this.onChangeSort(val,row)
            },
            currentChange(n) { // 分页
                this.page = n
                this.getListData('searchDatas')
            },
            getListData(searchDatas) { // 搜索接口
                this.$refs[searchDatas].validate((valid) => {
                    if (valid) {
                        let length = this.searchDatas.code.length
                        if (length < 4) {
                            // this.checkedCodesS = []
                            this.$message({
                                message: '请至少选择省以下行政级别',
                                type: "error"
                            });
                        } else {
                            this.addOrEdit()
                        }
                    } else {
                        this.$message({
                            message: '请填写正确输入条件',
                            type: "error"
                        });
                        return false;
                    }
                });
            },

            //处理选择的表格项
            handleSelectionChange(val) {
                console.log(val);
                let arr = val.map(item => {
                    return {
                        recommendStar: item.num,
                        thematicId: item.id
                    }
                })
                this.recommendThematicDTOList = arr
            }
        },
        created: function () {
            this.request.oprahfun(this);
            this.addOrEdit()
            this.getArea()
        },
        watch: {}
    };
</script>
<style lang="less" scoped>
    .search {
        height: 70px;
    }

    .pagination {
        margin-top: 15px;
    }

    .btn {
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<style lang="less">
    .addArea {
        .search {
            .el-input__inner {
                width: 250px;
                height: 30px;
                line-height: 30px;
            }

            .el-button {
                padding: 0;
                height: 30px;
                width: 80px;

            }
        }
        .el-form-item__label{
            line-height: 50px;
        }
    }
</style>